// apis
import { test } from "../../base/env";
import { realList } from "./real-api";
import { testList } from "./test-api";

const list = test ? testList : realList;

export const API = {
  get: {
    driversApp: list.drivers_app.driversApp,
    sliders: list.content.getSliders,
    categories: list.products.getCategories,
    productSliders: list.sellers.getProductSliders,
    sellerProducts: list.sellers.getSellerProducts,
    locationProvinces: list.locations.getLocationProvinces,
    locationCities: list.locations.getLocationCities,
    countries: list.locations.getCountries,
    productsSearch: list.sellers.getProductsSearch,
    productsFilters: list.sellers.getProductsFilters,
    captcha: list.accounts.getCaptcha,
    cities: list.locations.getCities,
    regions: list.locations.getRegions,
    pollQuestions: list.rates.getPollQuestions,
    returnableOrders: list.orders.getReturnableOrders,
    userAddresses: list.accounts.getUserAddresses,
    userCars: list.cars.getUserCars,
    // carsBrands: list.cars.getCarsBrands,
    carsModels: list.cars.getCarsModels,
    carsTypes: list.cars.getTypes,
    carsBrands: list.cars.getBrands,
    userBills: list.service_center.getUserBills,
    userOrders: list.orders.getUserOrders,
    userBill: list.service_center.getUserBill,
    userProfile: list.accounts.getUserProfile,
    userCredits: list.accounts.getUserCredits,
    credits: list.accounts.getCredits,
    serviceCenters: list.service_center.getServiceCenters,
    productDelivery: list.sellers.getProductDelivery,
    serviceCenterTypes: list.service_center.getServiceCenterTypes,
    couponOrders: list.service_center.getCouponOrders,
    faq: list.content.getFaqs,
    addressByUserLocation: list.locations.getAddressByUserLocation,
    getCategories: list.appointment.getCategories,
    getAppointments: list.appointment.getAppointments,
    getAppointment: list.appointment.getAppointment,
    customerInfo: list.service_center.getCustomerInfo,
    getServices: list.service_center.getServices,
    getServiceDetails: list.service_center.getServiceDetails,
    getStocks: list.stocks.getStocks,
    getEmployees: list.employees.getEmployees,
    getNotifications: list.notification.getNotifications,
    retrieveNotification: list.notification.retrieveNotification,
    languageIp: list.language.getLanguage,
    plateImage: list.service_center.getPlateImage,
  },
  post: {
    tokenLogin: list.accounts.postTokenLogin,
    notification: list.notification.postNotification,
    card: list.sellers.postCard,
    sendOtp: list.accounts.sendOtp,
    checkOtp: list.accounts.checkOtp,
    orderSummary: list.orders.postOrderSummary,
    requiredFields: list.orders.postRequiredFields,
    payment: list.orders.postPayment,
    returnedSummary: list.orders.postReturnedSummary,
    returned: list.orders.postReturned,
    returnedVerify: list.orders.postReturnedVerify,
    userAddresses: list.accounts.postUserAddresses,
    userCar: list.cars.postUserCar,
    uploadPlateImage: list.service_center.postPlateImage,
    rate: list.rates.postRate,
    customerInfo: list.service_center.postCustomerInfo,
    serviceInfo: list.service_center.postServiceInfo,
    otpValidationOnService: list.service_center.postOtpValidation,
    resendOtpValidationOnService: list.service_center.resendOtpValidation,
    createEmployee: list.employees.createEmployee,
    seenNotification: list.notification.seenNotification,
    qrLocation: list.qrLocation.postQRLocation,
  },
  del: {
    userAddresses: list.accounts.deleteUserAddresses,
    userCar: list.cars.deleteUserCar,
    deleteServiceDetails: list.service_center.deleteServiceDetails,
  },
  put: {
    userAddresses: list.accounts.putUserAddresses,
    userCar: list.cars.putUserCar,
    editProfile: list.accounts.putEditProfile,
    updateEmployee: list.employees.patchEmployee,
  },
};
